export default __webpack_public_path__ + "images/logo.v-3d006d16cc96d78b9b800912af7edbe0.png";